<template>
  <el-dialog :visible.sync="visible"
             :title="$t('message.uploadProfile')"
             :close-on-click-modal="false"
             width="30%">
    <el-upload
      :action="upLoadUrl"
      ref="imgUpload"
      :before-upload="beforeUpload"
      :on-exceed="exceedHandle"
      :on-success="successHandle"
      :on-error="errorHandle"
      :accept="'.jpg,.jpeg,.png,.gif,.bmp'"
      :auto-upload="false"
      :data="IDcardAdata"
      :with-credentials="true"
      :headers="upLoadHeaders"
      :limit="1"
      :on-change="handleChange"
      list-type="picture">
      <el-button size="small" type="primary">{{$t('message.uploadProfile2')}}</el-button>
      <div slot="tip" class="el-upload__tip">{{$t('message.uploadProfile3')}}</div>
    </el-upload>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      visible: false,
      count: 0,
      upLoadHeaders: {
        'Authorization': 'Bearer ' + getAccessToken()
      },
      IDcardAdata: {
        FILE_TYPE: 10,
        fileSuffixType: 'picture2'
      },
      upLoadUrl: `${window.SITE_CONFIG['apiURL']}/front/consumer/usercenter/uploadSysUserHeadPhoto`
    }
  },
  computed: {
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.imgUpload.clearFiles()
        this.count = 0
      })
    },
    handleChange (file, fileList) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      var reg = /\.(jpg|jpeg|png|gif|bmp)$/
      const isLt2M = file.size / 1024 / 1024 < 20
      const isJPG = reg.test(type)

      if (!isJPG) {
        this.$message.error(this.$t('message.uploadProfile4'))
        this.$refs.imgUpload.clearFiles()
      }
      if (!isLt2M) {
        this.$message.error(this.$t('message.uploadProfile5'))
        this.$refs.imgUpload.clearFiles()
      }
    },
    exceedHandle (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
      // this.$message.warning(`The current limit is 1 file, ${files.length} files Selected this time,a total of ${files.length + fileList.length} files`)
    },
    beforeUpload (file) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      const isLt2M = file.size / 1024 / 1024 < 20
      var reg = /\.(jpg|jpeg|png|gif|bmp)$/
      const isJPG = reg.test(type)

      if (!isJPG) {
        this.$message.error(this.$t('message.uploadProfile4'))
      }
      if (!isLt2M) {
        this.$message.error(this.$t('message.uploadProfile5'))
      }
      return isJPG && isLt2M
    },
    successHandle (response, file, fileList) {
      if (response.code === 0) {
        this.$message({
          message: this.$t('message.uploadSuccess'),
          type: 'success'
        })
        this.visible = false
        this.bus.$emit('refushUserInfo')
      } else {
        this.$refs.imgUpload.clearFiles()
        this.$message({
          message: response.message,
          type: 'error'
        })
      }
    },
    errorHandle (err, file, fileList) {
      this.$message.error(err.message || this.$t('message.uploadFailed'))
    },
    // 删除阿里图片
    deleteHandle (ids = []) {
      if (ids.length) {
        this.$http.post(`help/fileupload/sys/deleteBatchAliOss`, ids)
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      if (this.$refs.imgUpload.uploadFiles.length > 0) {
        this.$refs.imgUpload.submit()
      } else {
        this.$message.error(this.$t('message.selectPic'))
      }
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang='scss' scoped>
</style>
